var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#204E4A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2588_3209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4537 11.8397H17.6136L10.7822 20.5641L12.3788 13.1349L12.5088 12.5298H11.8899H7.83851L11.0062 3.9776H16.147L12.9961 11.1383L12.6874 11.8397H13.4537Z",
    fill: "#F8FD00",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2588_3209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 20,
    fill: "white",
    transform: "translate(7 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAction);
export default __webpack_public_path__ + "static/media/icon-action.e10d4b504d7eaafcf5c23b8e4e6d54fa.svg";
export { ForwardRef as ReactComponent };